<template>
    <div class="section profile">
        <div class="text-panel">
            <p class="headerText"><strong>Hi,</strong></p>
            <p>I'm a Creative Front-End Developer based in Utrecht, The Netherlands.<br/><br/>
                With 5 years of experience in the media industry, I utilized my expertise in development, design, and animation to 
                produce engaging responsive website campaigns, online banner advertisements, video composites, and rich media ads.<br/><br/>
                If you like what you see, feel free to click on the link above to get in
                contact with me.<br/><br/>I hope to hear from you soon!
            </p>

            <img class="signature" :src="require(`@/static/img/krista.svg`)" />
            
        </div>
    </div>
</template>
<script>
    // import { TimelineMax } from '@/vendor';

    export default {
        data()
        {
            return {
            };
        },

        mounted()
        {
            
        },

        methods: {

        }
    };
</script>
